import React from 'react';
import { Helmet } from 'react-helmet';
import PageWrapper from 'components/pageWrapper';
import Content from './content';
import classes from './styles.module.scss';

const Policy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy</title>
      </Helmet>
      <PageWrapper heading="Privacy Policy">
        <div className={classes.wrapper}>
          <Content />
        </div>
      </PageWrapper>
    </>
  );
};

export default Policy;
